<hyperkit-dialog class="hyperkit-component" headerText="HUNTER Premium">
  <div class="body">
    <div class="test">
      <div class="row column-one">
        <div class="content-wrapper">
          <img
            style="margin-right: 5px"
            width="24"
            height="24"
            src="/assets/img/icons/cyborg-premium.png"
          />
          <hyperkit-typography
            variant="body"
            size="md"
            align="left"
            color="body"
            >Elevate your threat hunting workbench with access to exclusive
            content and capabilities available only with HUNTER
            Premium.</hyperkit-typography
          >
          <div class="points">
            <ul>
              <li>
                <hyperkit-typography
                  variant="body"
                  size="md"
                  align="left"
                  color="body"
                  >Gain unrestricted access to Premium Hunt Packages for all
                  security tools.</hyperkit-typography
                >
              </li>
              <li>
                <hyperkit-typography
                  variant="body"
                  size="md"
                  align="left"
                  color="body"
                  >Complete access to the hunt packages included in the Emerging
                  Threats Collections.</hyperkit-typography
                >
              </li>
              <li>
                <hyperkit-typography
                  variant="body"
                  size="md"
                  align="left"
                  color="body"
                  >Direct line of communication with the Intel 471 Threat Hunt
                  team via the Hunt Package Feedback
                  Feature.</hyperkit-typography
                >
              </li>
              <li>
                <hyperkit-typography
                  variant="body"
                  size="md"
                  align="left"
                  color="body"
                  >Access to Threat Hunt Syncs with Intel 471 Threat Hunters as
                  a part of the Customer Success Program.</hyperkit-typography
                >
              </li>
              <li>
                <hyperkit-typography
                  variant="body"
                  size="md"
                  align="left"
                  color="body"
                  >To plan, execute, report and manage the Hunt Packages, ask
                  about access to the HUNTER Hunt Module.</hyperkit-typography
                >
              </li>
            </ul>
          </div>
          <hyperkit-button
            size="small"
            color="tertiary"
            text=" Talk to an Intel 471 Expert"
            (click)="talkToCyborg()"
          ></hyperkit-button>
        </div>
        <video
          loop
          controls
          oncanplay="this.play()"
          onloadedmetadata="this.muted = true"
        >
          <source
            src="https://go.intel471.com/hubfs/HUNTER%20Platform/Hunter%20Premium%20-%20Match%20Source%20-%202.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  </div>
</hyperkit-dialog>
